module.exports = __webpack_public_path__ + "static/media/proden.99dae4eb.png";